// Single source of truth for which reward categories are available per
// platform and delivery mode. Shared by the reward catalogue's category
// picker (Services/Rewards/CategoryInput.tsx) and the Manual Order
// Redemption dialog (Reward/components/ManualRedemptionDialog.tsx) so a
// category/platform change only needs to be made in one place.
export const REWARD_CATEGORY_BY_PLATFORM_AND_DELIVERY_MODE: Record<
  string,
  Record<string, string[]>
> = {
  M21: {
    "AUTO-ORDER": ["IDD", "SMS", "RELOAD"],
    "COUPON-CODE": ["VAS"],
    "VOUCHER-CODE": ["SOUVENIR"],
  },
  GHK: {
    "AUTO-ORDER": ["IDD", "SMS", "BALANCE", "MVNO"],
    "COUPON-CODE": ["VAS", "MVNO"],
    "VOUCHER-CODE": ["SOUVENIR"],
  },
  G2: {
    "COUPON-CODE": ["VAS"],
    "VOUCHER-CODE": ["SOUVENIR"],
  },
};

// Flattens the per-delivery-mode categories for a platform into the
// deduplicated union the Manual Order Redemption dialog needs, since it
// picks a category directly without a delivery-mode step.
export const getRewardCategoriesForPlatform = (
  platform: string | undefined
): string[] => {
  const byDeliveryMode = platform
    ? REWARD_CATEGORY_BY_PLATFORM_AND_DELIVERY_MODE[platform]
    : undefined;
  if (!byDeliveryMode) return [];
  return Array.from(new Set(Object.values(byDeliveryMode).flat()));
};
